import { Component } from '@angular/core';
import { Vehicle } from 'src/app/Models/vehicle';
import { ApiService } from '../../core/services/api.service';
import { MessageService } from '../../core/services/message.service';
import { HttpParams } from '@angular/common/http';
import { ComboDto } from '../../dtos/combo-dto';
@Component({
    selector: 'reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})

export class ReportsComponent {

  vehicles: ComboDto[] = [];
  selectedVehicleStatus: any;
  initDate: Date = new Date();
  endDate: Date = new Date();
  reports: any[] = [{value:1, text:"Reporte de encuestas"}, {value: 2, text: 'Reporte de entregas'}, {value: 3, text: 'Reporte motivos rechazo y cantidad'},
                    {value: 4, text: 'Reporte tiempos transito y descarga '}];
  selectedReport: any = 1;
    
    constructor(private apiService: ApiService, private messageService: MessageService) {
      this.getVehicles();
    }
    downloadFile(url: string, fileName: string, params: HttpParams) {
        let responseType = 'arraybuffer';
        this.apiService.getRawResponse(url, responseType, params).subscribe((res: any) => {
            let filename = fileName;
            let type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            let response = res;
            let blob = new Blob([response], { type: type });
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                window.navigator.msSaveBlob(blob, filename);
            } else {
                var URL = window.URL;
                var downloadUrl = URL.createObjectURL(blob);
                var a = window.document.createElement("a");
                a.href = downloadUrl;
                a.download = filename;
                a.click();
            }
            setTimeout(() => { URL.revokeObjectURL(downloadUrl); }, 100);
        });
    }
    downloadDocument() {
        let params = new HttpParams();
        if (this.selectedVehicleStatus) {
          params = params.append('vehicleId', this.selectedVehicleStatus+'');
        }
        if (this.initDate) {
          params = params.append('initDate', new Date(this.initDate).toISOString());
        }
        if (this.endDate) {
          params = params.append('endDate', new Date(this.endDate).toISOString());
        }
        switch(this.selectedReport){
          case 1:
                  this.downloadFile('/api/report/survey', "reporte_encuestas.xlsx", params);
          break;
          case 2: this.downloadFile('api/report/delivery', 'reporte_entregas.xlsx', params);
          break;
          case 3: this.downloadFile('api/report/reject', 'report_reject_material.xlsx', params);
          break;
          case 4: this.downloadFile('api/report/times', 'report_times_ships.xlsx', params);
          break;
        }
      }

getVehicles() {
    this.apiService.get('api/vehicle/getVehicleCombo').subscribe((response: any) => {
      if (response) {
        this.vehicles.push(new ComboDto(0, 'GENERAL.LABELS.ALL'));
        this.vehicles = this.vehicles.concat(response);
        debugger;
/*        
        this.vehicles = response.data;
        let first = new Vehicle();
        first.id = 0;
        first.registerNumber = 'GENERAL.LABELS.VEHICLES';
        this.vehicles.splice(0, 0, first);
        console.log('vehicles');
        console.dir(this.vehicles);
        this.selectedVehicleStatus = this.vehicles[0].id;
*/
      }
    })
  }

  getReportDelivery(url: string, fileName: string, params: HttpParams){
    let responseType = 'arraybuffer';
    this.apiService.getRawResponse(url, responseType, params).subscribe((res: any)=>{
      let filename = fileName;
      let type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      let response = res;
      let blob = new Blob([response], { type: type });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename);
      } else {
          var URL = window.URL;
          var downloadUrl = URL.createObjectURL(blob);
          var a = window.document.createElement("a");
          a.href = downloadUrl;
          a.download = filename;
          a.click();
      }
      setTimeout(() => { URL.revokeObjectURL(downloadUrl); }, 100);
    });
  }

  getHistoryReject(url: string, fileName: string, params: HttpParams){
    let responseType = 'arraybuffer';
    this.apiService.getRawResponse(url, responseType, params).subscribe((res: any)=>{
      let filename = fileName;
      let type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      let response = res;
      let blob = new Blob([response], { type: type });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename);
      } else {
          var URL = window.URL;
          var downloadUrl = URL.createObjectURL(blob);
          var a = window.document.createElement("a");
          a.href = downloadUrl;
          a.download = filename;
          a.click();
      }
      setTimeout(() => { URL.revokeObjectURL(downloadUrl); }, 100);
    });
  }
}
